module.exports = __webpack_public_path__ + "img/galeria-ornamentais-1.cd7f31f2.jpg";